module.exports = __webpack_public_path__ + "static/media/Q1.ddba4769.png";